module.exports = __webpack_public_path__ + "img/i_es_internet.237e5de4.svg";